mutation PreviewCustomerGuideDraft($input: CustomerGuideDraftPreviewInput!) {
  previewCustomerGuideDraft(input: $input) {
    pdfDataUrl
  }
}
